import React from 'react';

import {
  NestedArrayObjectField,
  NestedArrayStringField,
  NestedArraySelectField
} from 'components/Common/Inputs';
import normalizeFullWidthChars from 'common/App/normalizeFullWidthChars';

/* eslint-disable react/no-array-index-key */

const TINQuestions = () => (
  <div className="tin-questions">
    <p>Please provide your Tax Identification Number (TIN) against all the countries you have confirmed tax residency.</p>
    <p>If a TIN is unavailable please select the appropriate reason <strong>A</strong>, <strong>B</strong> or <strong>C</strong>:</p>
    <div>
      <p><strong>Reason A</strong></p>
      <p>The country where the Account Holder is liable to pay tax does not issue TINs to its residents.</p>
    </div>
    <div>
      <p><strong>Reason B</strong></p>
      <div>
        <p>The Account Holder is otherwise unable to obtain a TIN or equivalent number. Please explain why you are unable to obtain a TIN in the below table if you have selected this reason.</p>
      </div>
    </div>
    <div>
      <p><strong>Reason C</strong></p>
      <div>
        <p>No TIN is required. Note - Only select this reason if the authorities of the country of tax residence entered below do not require the TIN to be disclosed.</p>
      </div>
    </div>

    <div>
      <table className="table table-striped table-hover table-bordered">
        <colgroup>
          <col className="col-1" />
          <col className="col-2" />
          <col className="col-3" />
          <col className="col-4" />
        </colgroup>
        <thead>
          <tr>
            <th colSpan="2">Country of tax residence</th>
            <th>TIN</th>
            <th>If no TIN available select Reason A, B or C</th>
          </tr>
        </thead>
        <tbody>
          {Array(3).fill(0).map((el, index) => (
            <tr key={ index }>
              <td>{ index + 1 }</td>
              <td className="form-group">
                <NestedArrayObjectField
                  formName="questionnaire-form"
                  name={ `accountHolderTaxInfo[${ index }].countryOfTaxResidence` }
                  rootField="accountHolderTaxInfo"
                />
              </td>
              <td className="form-group">
                <NestedArrayObjectField
                  formName="questionnaire-form"
                  name={ `accountHolderTaxInfo[${ index }].taxIdNumber` }
                  rootField="accountHolderTaxInfo"
                  normalizeFn={ normalizeFullWidthChars }
                />
              </td>
              <td className="form-group">
                <NestedArraySelectField
                  formName="questionnaire-form"
                  name={ `accountHolderTaxInfo[${ index }].noTaxIdNumberReason` }
                  rootField="accountHolderTaxInfo"
                >
                  <option value="">Please select a reason</option>
                  <option value="A">Reason A</option>
                  <option value="B">Reason B</option>
                  <option value="C">Reason C</option>
                </NestedArraySelectField>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    <div>
      <p className="reason-b-text">
        Please explain in the following boxes why you are unable to obtain a TIN if you selected <strong>Reason B</strong> above.
      </p>
    </div>
    <div>
      <table className="table table-striped table-hover table-bordered">
        <colgroup>
          <col className="col-1" />
          <col className="col-2to4" />
        </colgroup>
        <tbody>
          {Array(3).fill(0).map((el, index) => (
            <tr key={ index }>
              <td>{ index + 1 }</td>
              <td className="form-group">
                <NestedArrayStringField
                  formName="questionnaire-form"
                  name={ `reasonUnableToObtainTin[${ index }]` }
                  rootField="reasonUnableToObtainTin"
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);
/* eslint-enable react/no-array-index-key */

export default TINQuestions;
